/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  Header,
  AppCardListComp,
  NewHolderGroupModal,
  SettingsComp,
} from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMPayoutGetContent,
  useSMAddGroup,
} from '@pages/PayoutPage/machines';
import { PayoutPageService } from '@pages/PayoutPage/services';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';

const getSrv = () => {
  return vappContainer.get<PayoutPageService>(PayoutPageService.name);
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    // srv?.resetCriteria();
  }, []);

  const { payoutPageMachine, payoutPageState, payoutPageSend } =
    useSMPayoutGetContent({});

  const { addGroupMachine, addGroupSend, addGroupState } = useSMAddGroup({});

  const onHeaderAction1Click = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  const onError = () => {
    payoutPageSend('TRIGGER_REFRESH', {});
  };

  const onPageChange = (page: number) => {
    console.log(`page change`, page);

    payoutPageSend('TRIGGER_REFRESH', {
      offset: (page - 1) * 10,
      size: 10,
    });
  };

  const onRefresh = () => {
    payoutPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onPaymentSubmit = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    // updateProfileSend("START", {
    //   payload: {
    //     firstName:data?.firstName,
    //     lastName:data?.lastName,
    //     primaryContactNo:data?.primaryContactNo,
    //     image: data?.image?.base64,
    //     address:{
    //       addressLine1:data?.streetAddress,
    //       city:data?.city,
    //       country:data?.country
    //     }
    //   },
    // });
  };
  const onClearFilter = () => {
    // srv?.resetCriteria();
    payoutPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotifications = () => {
    if (addGroupState?.matches('ADD_GROUP_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPagePayoutSync()?.notifications
            .addGroupSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const onPaginationChange = (event: any) => {
    payoutPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const onApplyFilter = (data: any) => {
    console.log('on apply filter', data);
    let criteria = {};
    criteria = {
      ...data,
    };

    payoutPageSend('TRIGGER_REFRESH', {
      criteria: criteria,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(payoutPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={payoutPageState?.event?.data?.value?.appCardList?.length}
      />
    );
  };

  const _renderPayout = () => {
    if (addGroupState?.matches('ADD_GROUP')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingPayoutSync()?.loading?.loadingAddGroup ||
            {})}
        />
      );
    }

    if (payoutPageState?.matches('RENDER_PAYOUT')) {
      return (
        <>
          {payoutPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingPayoutSync()?.loading?.usersEmpty ||
                {})}
            />
          ) : (
            <AppCardListComp
              {...(payoutPageState?.event?.data?.value || {})}
              onCardClick={props?.onCardClick}
              onPageChange={onPageChange}
            />
          )}
        </>
      );
    }
    if (payoutPageState?.matches('GET_PAYOUT_CONTENT')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingPayoutSync()?.loading
            ?.loadingHolderGroup || {})}
        />
      );
    }
    if (payoutPageState?.matches('RENDER_PAYOUT_ERROR')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingPayoutSync()?.loading?.eventListEmpty ||
            {})}
        />
      );
    }

    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getStaticPagePayoutSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getStaticPagePayoutSync()?.header || {})}
            onHeaderAction1Click={onHeaderAction1Click}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderSearch = () => {
    return (
      <SettingsComp
        {...srv?.agent?.getStaticPagePayoutSync()?.settings}
        onApplyFilter={onApplyFilter}
        onClearFilter={onClearFilter}
      />
    );
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        // <NewHolderGroupModal
        //   {...staticPageContentConfig?.addGroup}
        //   showModal={showModal}
        //   onAcknowledgement={onNewHolderGroup}
        // />
        <TweetyModal
          show={true}
          //  size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onPaymentSubmit}
          onHide={() => setShowModal(false)}
          title={'Add New Country'}
          tweetyWidgetProps={{
            fields: srv?.agent?.getAddCountrySync()?.addCountry?.FIELDS,
            layout: srv?.agent?.getAddCountrySync()?.addCountry?.layout,
          }}
        />
      );
    }
  };
  const _renderErrorModals = () => {
    if (addGroupState?.matches('ADD_GROUP_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorPayoutSync()?.error?.addGroup || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    // if (payoutPageState?.matches("RENDER_PAGE_ERROR")) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(staticPageContentConfig?.error?.getGroup || {})}
    //       onAcknowledgement={onError}
    //       onDeny={onError}
    //     />
    //   );
    // }
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderSearch()}
        {_renderPayout()}
        {_renderErrorModals()}
        {_renderPagination()}
        {_renderModal()}
        {_renderNotifications()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
